/* istanbul ignore file */

import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: ${pxToRem(spacing.xl)} 0 ${pxToRem(100)};

  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      margin: ${pxToRem(spacing.xxl)} 0 ${pxToRem(spacing.xxxl)};
    `,
  )}
`;

export const productListSidebar = css`
  grid-column: 2 / span 2;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: none;
    `,
  )};
`;

export const productListWrapper = css`
  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      padding: 0;
    `,
  )};
`;

export const breadcrumbContainer = css`
  grid-column: 1 / -1;
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 2 / -2;
    `,
  )}
`;
